import { useMemo } from 'react'
import type { BasicTrip } from 'tripPlanner/types/common'

export interface TripData {
  lat: number | undefined
  lng: number | undefined

  location: string | undefined

}

interface UseHomePageTripDataParams {
  orders: Array<App.Order>
  selectedTrip?: BasicTrip
}

export const useHomePageTripData = ({ orders, selectedTrip }: UseHomePageTripDataParams): TripData => {
  const tripData = useMemo(() => {
    let relevantOrder: App.Order | undefined

    if (selectedTrip?.orderIds && selectedTrip.orderIds.length > 0) {
      relevantOrder = orders.find(order => selectedTrip.orderIds?.includes(order.id))
    }

    if (!relevantOrder && orders && orders.length > 0) {
      relevantOrder = orders[0]
    }

    if (relevantOrder) {
      if (relevantOrder.items && relevantOrder.items.length > 0) {
        return {
          lat: relevantOrder.items[0].offer?.property?.latitude,
          lng: relevantOrder.items[0].offer?.property?.longitude,
          location: relevantOrder.items[0].offer?.property?.locationHeading,
        }
      } else if (relevantOrder.bedbankItems && relevantOrder.bedbankItems.length > 0) {
        return {
          lat: relevantOrder.bedbankItems[0].offer?.property?.latitude,
          lng: relevantOrder.bedbankItems[0].offer?.property?.longitude,
          location: relevantOrder.bedbankItems[0].offer?.property?.address?.city,
        }
      }
    }

    return {
      lat: undefined,
      lng: undefined,
      location: undefined,
    }
  }, [orders, selectedTrip])

  return tripData
}
